import React, { useState, useEffect, useRef } from "react";
import TextField from "@material-ui/core/TextField";
import Container from "@material-ui/core/Container";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Checkbox from "@material-ui/core/Checkbox";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import Radio from "@material-ui/core/Radio";
import RadioGroup, { RadioGroupProps } from "@material-ui/core/RadioGroup";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import VerbFrequencyIcon from "../cards/VerbFrequencyIcon";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import { getFirestore } from "redux-firestore";
import "./Gender.scss";
import WordSummary from "../dashboard/WordSummary";
import FavoriteIcon from "@material-ui/icons/FavoriteTwoTone";
import VolumeIcon from "@material-ui/icons/VolumeDownTwoTone";
import VolumeOffIcon from "@material-ui/icons/VolumeOffTwoTone";
import VisibilityIcon from "@material-ui/icons/VisibilityOffTwoTone";
import GenderMenu from "./GenderMenu";
import SpeakGender from "./SpeakGender";
import EditGenderDialog from "./EditGenderDialog";

const Gender = (props) => {
  const [Word, setWord] = useState(null);
  const [SelectedIndex, setSelectedIndex] = useState(0);
  const [ReadPlural, setReadPlural] = useState(true);
  const [ReadWord, setReadWord] = useState(true);
  const [ReadExample, setReadExample] = useState(false);
  const [ShowAll, setShowAll] = useState(false);
  const [OpenEditDialog, setOpenEditDialog] = useState(false);

  const childRef = useRef();

  useEffect(() => {
    console.log("Load");
    LoadData_API(false);
  }, []);

  useEffect(() => {
    console.log(SelectedIndex);
  }, [SelectedIndex]);

  const LoadData_API = (ShowAll) => {
    let firestore = getFirestore();
    let single_document = {};
    let data = [];
    firestore
      .collection("gender")
      .where("Skip", "==", ShowAll)
      .orderBy("createdAt", "desc")
      // .limit(5)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach(function (doc) {
          single_document = doc.data();
          single_document.id = doc.id;
          data.push(single_document);
        });
        setWord(data);
        console.log(data);
      });
  };

  const Shuffle = () => {
    let array = Word;
    for (var i = array.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = array[i];
      array[i] = array[j];
      array[j] = temp;
    }
    setWord(array);
  };

  const CheckAnswer = (answer) => {
    if (Word[SelectedIndex].Article == answer) {
      let article = "";
      if (Word[SelectedIndex].Article == "M") article = "Der";
      else if (Word[SelectedIndex].Article == "F") article = "Die";
      else article = "Das";
      if (ReadWord)
        childRef.current.SpeakText(article + " " + Word[SelectedIndex].Word);
      if (ReadPlural)
        childRef.current.SpeakText(" . " + Word[SelectedIndex].Plural);
      if (ReadExample)
        childRef.current.SpeakText(" . " + Word[SelectedIndex].Example);
      let newIndex = SelectedIndex + 1;
      if (newIndex >= Word.length) {
        newIndex = 0;
      }
      setSelectedIndex(newIndex);
      setTimeout(childRef.current.SpeakText, 1300, Word[newIndex].Word);
    }
  };

  const handleShowAllClick = () => {
    LoadData_API(!ShowAll);
    setShowAll(!ShowAll);
  };
  const handleBookmarkClick = () => {
    let tempWord = [...Word];
    tempWord[SelectedIndex].Bookmark = !tempWord[SelectedIndex].Bookmark;
    setWord(tempWord);
  };
  const handleVolumePluralClick = () => {
    setReadPlural(!ReadPlural);
  };
  const handleVolumeWordClick = () => {
    setReadWord(!ReadWord);
  };
  const handleVolumeExampleClick = () => {
    setReadExample(!ReadExample);
  };
  const handleSkipClick = () => {
    let tempWord = [...Word];
    // let skip = 0;
    // if (tempWord[SelectedIndex].Skip === 0) {
    //   skip = 1;
    // }
    tempWord[SelectedIndex].Skip = !tempWord[SelectedIndex].Skip;
    setWord(tempWord);
  };
  const handleLevelClick = (Level) => {
    let tempWord = [...Word];
    tempWord[SelectedIndex].Level = Level;
    setWord(tempWord);
  };

  const UpdateField = (fieldName, value) => {
    let tempWord = [...Word];
    tempWord[SelectedIndex][fieldName] = value;
    setWord(tempWord);
  };

  const handleCloseEditDialog = (wordUpdated, newWord) => {
    setOpenEditDialog(false);
    if (wordUpdated === true) {
      Word[SelectedIndex] = {
        ...newWord,
        createdAt: Word[SelectedIndex].createdAt,
        id: Word[SelectedIndex].id,
      };
      // Word[SelectedIndex].Word = newWord.Word;
      // Word[SelectedIndex].Article = newWord.Article;
      // Word[SelectedIndex].Example = newWord.Example;
      // Word[SelectedIndex].Plural = newWord.Plural;
      // Word[SelectedIndex].Frequency = newWord.Frequency;
      // Word[SelectedIndex].Skip = newWord.Skip;
      // Word[SelectedIndex].ReadExample = newWord.ReadExample;
      // Word[SelectedIndex].Bookmark = newWord.Bookmark;
      // Word[SelectedIndex].Level = newWord.Level;
      // Word[SelectedIndex].Rule = newWord.Rule;
    }
  };

  const handleEditRedirect = (id) => {
    //    let index = this.state.words.findIndex((e) => e.id == id)
    setOpenEditDialog(true);
    // props.history.push("/addgender", Word[SelectedIndex]);
  };

  return (
    <Container maxWidth="xl">
      <Paper className="paper-container">
        <SpeakGender ref={childRef}></SpeakGender>
        {Word && Word.length > 0 && (
          <main className="container white gender-component">
            <GenderMenu
              handleSkipClick={handleSkipClick}
              handleLevelClick={handleLevelClick}
              handleBookmarkClick={handleBookmarkClick}
              handleShowAllClick={handleShowAllClick}
              UpdateField={UpdateField}
              handleEditRedirect={handleEditRedirect}
              SelectedIndex={SelectedIndex}
              ShowAll={ShowAll}
              Counter={Word.length}
              Word={Word[SelectedIndex]}
              Shuffle={Shuffle}
            ></GenderMenu>

            <div className="word">
              <div className="word__plural">
                <IconButton
                  className="word__plural__icon"
                  onClick={() => handleVolumePluralClick()}
                  color="default"
                >
                  {ReadPlural ? <VolumeIcon /> : <VolumeOffIcon />}
                </IconButton>
                <div
                  className="word__plural__text"
                  onClick={() =>
                    childRef.current.SpeakText(Word[SelectedIndex].Plural)
                  }
                >
                  {Word[SelectedIndex].Plural}
                </div>
              </div>
              <p
                className="word__text"
                onClick={() =>
                  childRef.current.SpeakText(Word[SelectedIndex].Word)
                }
              >
                {Word[SelectedIndex].Word}
              </p>
              <div className="word__footer">
                <IconButton
                  onClick={() => handleVolumeWordClick()}
                  color="default"
                >
                  {ReadWord ? <VolumeIcon /> : <VolumeOffIcon />}
                </IconButton>
              </div>
            </div>
            {/* <div className="article">Der</div> */}
            <div
              className="example"
              onClick={() =>
                childRef.current.SpeakText(Word[SelectedIndex].Example)
              }
            >
              <div className="example__text">{Word[SelectedIndex].Example}</div>
              <div className="example__footer">
                <IconButton
                  onClick={() => handleVolumeExampleClick()}
                  color="default"
                >
                  {ReadExample ? <VolumeIcon /> : <VolumeOffIcon />}
                </IconButton>
                <IconButton
                  onClick={() => handleBookmarkClick()}
                  color="default"
                >
                  <VisibilityIcon />
                </IconButton>
              </div>
            </div>

            <section className="buttons">
              <button className="der" onClick={() => CheckAnswer("M")}>
                Der
              </button>
              <button className="die" onClick={() => CheckAnswer("F")}>
                Die
              </button>
              <button className="das" onClick={() => CheckAnswer("N")}>
                Das
              </button>
            </section>
            <EditGenderDialog
              open={OpenEditDialog}
              word={Word[SelectedIndex]}
              handleClose={handleCloseEditDialog}
            ></EditGenderDialog>
          </main>
        )}
      </Paper>
    </Container>
  );
};

export default Gender;
